import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, DestroyRef, inject } from '@angular/core';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { DynamicFieldsetModule, FsOnAfterSaveEvent, ModelFormServiceFactory } from '@common/forms/frontend-shared';
import { UiButtonComponent } from '@common/ui/frontend-shared/button';
import { PasswordResetRequest, ValidateResetTokenRequest } from '@common/users-password-reset-qrcode/shared';
import { AccessService, AccessState, AppRequestService, LocalMessageHandlerService, RouterLinkResolverPipe, takeWhileAlive } from '@core/frontend-shared';
import { roleCheck, UserRole } from '@core/shared/access';
import { ConfigService } from '@core/shared/config';
import { Store } from '@ngxs/store';
import { dayjs } from '@core/shared/utils/dayjs';
import { jwtDecode } from 'jwt-decode';
import { filter, map } from 'rxjs';
import { UiContentCenteredComponent } from '@common/ui/frontend-shared/content-centered';
import { UiIconsModule } from '@common/ui/frontend-shared/icons';
import { UiMessageComponent } from '@common/ui/frontend-shared/message';
import { UiSpinnerComponent } from '@common/ui/frontend-shared/spinner';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { UiFieldWrapperComponent } from '@common/ui/frontend-shared/field-wrapper';
import { UiInputTextComponent } from '@common/ui/frontend-shared/input-text';
import { AppMessagesComponent } from '@common/messages/frontend-shared';
import * as i0 from "@angular/core";
import * as i1 from "@core/frontend-shared";
import * as i2 from "@angular/router";
import * as i3 from "@core/shared/config";
import * as i4 from "@ngxs/store";
import * as i5 from "@common/forms/frontend-shared";
import * as i6 from "@angular/forms";
import * as i7 from "@common/ui/frontend-shared/card";
import * as i8 from "../../../../../../forms/frontend-shared/src/lib/form-submit-button/form-submit-button.directive";
import * as i9 from "@angular/common";
function PasswordResetQrcodeComponent_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "date");
    i0.ɵɵelement(3, "br");
    i0.ɵɵtext(4, " G\u00FCltig f\u00FCr Mitarbeiter von ");
    i0.ɵɵelementStart(5, "b");
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" Zugangslink g\u00FCltig bis: ", i0.ɵɵpipeBind2(2, 2, ctx_r0.tokenExpiry, "medium"));
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate(ctx_r0.companyName);
  }
}
function PasswordResetQrcodeComponent_Conditional_6_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "ui-message", 3)(1, "p");
    i0.ɵɵtext(2, " Liebe Mitarbeiter, um Ihr Passwort zur\u00FCckzusetzen, ben\u00F6tigen Sie einen speziellen Link. Bitte wenden Sie sich an Ihren Pflegedienstleiter / Ihre Pflegedienstleiterin, um diesen zu erhalten. ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "p");
    i0.ɵɵtext(4, " Liebe PflegedienstleiterInnen / Manager, falls Sie Ihr Passwort vergessen haben, wenden Sie sich bitte direkt an unseren Kundensupport. ");
    i0.ɵɵelementEnd()();
  }
}
function PasswordResetQrcodeComponent_Conditional_6_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "ui-message", 4);
    i0.ɵɵtext(1, " Der Zugriff \u00FCber einen Link ist zeitlich begrenzt. Bitte fragen Sie Ihren Pflegedienstleiter / Ihre Pflegedienstleiterin nach einem aktuellen Link/QR-Code. ");
    i0.ɵɵelementEnd();
  }
}
function PasswordResetQrcodeComponent_Conditional_6_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "ui-message", 4);
    i0.ɵɵtext(1, " Diese Seite darf aus Sicherheitsgr\u00FCnden ausschlie\u00DFlich f\u00FCr Mitarbeiter-Accounts genutzt werden. Ihr Account hat hingegen Manager- oder Administrationsrechte. Sollten Sie Ihre Zugangsdaten verloren haben, kontaktieren Sie bitte unseren Kundensupport. ");
    i0.ɵɵelementEnd();
  }
}
function PasswordResetQrcodeComponent_Conditional_6_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "ui-message", 4);
    i0.ɵɵtext(1, " Der angegebene Zugangscode ist nicht g\u00FCltig f\u00FCr Mitarbeiter Ihres Unternehmens/Einrichtung. ");
    i0.ɵɵelementEnd();
  }
}
function PasswordResetQrcodeComponent_Conditional_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵconditionalCreate(0, PasswordResetQrcodeComponent_Conditional_6_Conditional_0_Template, 5, 0, "ui-message", 3);
    i0.ɵɵconditionalCreate(1, PasswordResetQrcodeComponent_Conditional_6_Conditional_1_Template, 2, 0, "ui-message", 4);
    i0.ɵɵconditionalCreate(2, PasswordResetQrcodeComponent_Conditional_6_Conditional_2_Template, 2, 0, "ui-message", 4);
    i0.ɵɵconditionalCreate(3, PasswordResetQrcodeComponent_Conditional_6_Conditional_3_Template, 2, 0, "ui-message", 4);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵconditional(ctx_r0.noTokenError ? 0 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.expiredTokenError ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.invalidUserRoleError ? 2 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.invalidTeamError ? 3 : -1);
  }
}
function PasswordResetQrcodeComponent_Conditional_7_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "ui-spinner");
  }
}
function PasswordResetQrcodeComponent_Conditional_7_Conditional_2_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "form", 6, 0);
    i0.ɵɵlistener("ngSubmit", function PasswordResetQrcodeComponent_Conditional_7_Conditional_2_Conditional_0_Template_form_ngSubmit_0_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r0.formService.save());
    });
    i0.ɵɵelementStart(2, "ui-field-wrapper", 7);
    i0.ɵɵelement(3, "ui-input-text", 8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "ui-field-wrapper", 7)(5, "div");
    i0.ɵɵelement(6, "ui-input-text", 9);
    i0.ɵɵelementStart(7, "small");
    i0.ɵɵtext(8, "Ihr Passwort muss mindestens 6 Zeichen - mindestens eine Ziffer sowie Gro\u00DF- und Kleinbuchstaben - enthalten.");
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(9, "ui-field-wrapper", 7);
    i0.ɵɵelement(10, "ui-input-text", 10);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(11, "br")(12, "app-messages");
    i0.ɵɵelementStart(13, "div", 11);
    i0.ɵɵelement(14, "button", 12);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("formGroup", ctx_r0.formService.formGroup);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("placeholder", ctx_r0.usernameLabel);
    i0.ɵɵadvance();
    i0.ɵɵproperty("autocomplete", false);
    i0.ɵɵadvance();
    i0.ɵɵproperty("placeholder", "Neues Passwort");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("autocomplete", false);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("placeholder", "Neues Passwort Wiederh.");
    i0.ɵɵadvance();
    i0.ɵɵproperty("autocomplete", false);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("formSubmitButton", ctx_r0.formService);
  }
}
function PasswordResetQrcodeComponent_Conditional_7_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵconditionalCreate(0, PasswordResetQrcodeComponent_Conditional_7_Conditional_2_Conditional_0_Template, 15, 8, "form", 5);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵconditional(!ctx_r0.loading && !ctx_r0.completed ? 0 : -1);
  }
}
function PasswordResetQrcodeComponent_Conditional_7_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "ui-message", 13);
    i0.ɵɵtext(2, "Sie k\u00F6nnen sich nun mit Ihrem neuen Passwort einloggen.");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "br")(4, "button", 14);
    i0.ɵɵpipe(5, "resolveRouterLink");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("routerLink", i0.ɵɵpipeBind1(5, 1, "login"));
  }
}
function PasswordResetQrcodeComponent_Conditional_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵconditionalCreate(0, PasswordResetQrcodeComponent_Conditional_7_Conditional_0_Template, 1, 0, "ui-spinner");
    i0.ɵɵpipe(1, "async");
    i0.ɵɵconditionalBranchCreate(2, PasswordResetQrcodeComponent_Conditional_7_Conditional_2_Template, 1, 1);
    i0.ɵɵconditionalCreate(3, PasswordResetQrcodeComponent_Conditional_7_Conditional_3_Template, 6, 3, "div");
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵconditional(ctx_r0.loading || i0.ɵɵpipeBind1(1, 2, ctx_r0.formService.state$).busy ? 0 : 2);
    i0.ɵɵadvance(3);
    i0.ɵɵconditional(ctx_r0.completed ? 3 : -1);
  }
}
/**
 * Should token be static or flexible? different token per manager?
 * Security Steps:
 * 1) check if token is set
 * 2) check if user is admin / manager / superuser, if so, block it
 * 3) if user is logged in, check if he/she is a member of company specified in token
 */
export let PasswordResetQrcodeComponent = /*#__PURE__*/(() => {
  class PasswordResetQrcodeComponent {
    get hasSecurityError() {
      return this.noTokenError || this.expiredTokenError || this.invalidUserRoleError || this.invalidTeamError;
    }
    constructor(messages, route, router, access, api, cd, config, store, formServiceFactory) {
      this.messages = messages;
      this.route = route;
      this.router = router;
      this.access = access;
      this.api = api;
      this.cd = cd;
      this.config = config;
      this.store = store;
      this.destroyRef = inject(DestroyRef);
      this.loading = true;
      this.submitting = false;
      this.completed = false;
      this.noTokenError = false;
      this.expiredTokenError = false;
      this.invalidUserRoleError = false;
      this.invalidTeamError = false;
      this.predefinedUsername = false;
      this.usernameLabel = this.config.get('users.usernameIsEmail', false) ? 'E-Mail-Adresse' : 'Benutzername';
      this.formService = formServiceFactory.useDestroyRef(this.destroyRef).createModelForm(PasswordResetRequest);
      // token security
      const token = route.snapshot.queryParams.token;
      // remove token from URL. We don't really want the token to be visible and easy-to-copy.
      this.router.navigate(['./'], {
        relativeTo: this.route
      });
      if (!token) {
        this.noTokenError = true;
        this.cd.markForCheck();
        return;
      }
      this.validateToken(token).subscribe(decodedToken => {
        // eager check for token validity / warning display
        // more transparency for users instead of doing a late validation when sending the reset request itself
        if (!decodedToken) {
          this.expiredTokenError = true;
          this.cd.markForCheck();
          return false;
        } else {
          this.token = token;
          this.tokenExpiry = dayjs.unix(decodedToken.exp).toDate();
          this.companyId = decodedToken.data.companyId;
          this.companyName = decodedToken.data.companyName;
          // if logged in, we can run additional eager checks making sure this account is allowed to reset password by qrcode.
          const loggedIn = this.store.selectSnapshot(AccessState.loggedIn);
          if (loggedIn) this.checkUserAccount(decodedToken);
          // if has errors, there's no need to configurate form, it will not be displayed.
          if (!this.hasSecurityError) {
            this.initializeFormService();
          }
          this.loading = false;
          this.cd.markForCheck();
        }
      });
    }
    initializeFormService() {
      this.formService.setInitialValue({
        token: this.token
      });
      if (this.predefinedUsername) this.formService.setImmutableValues({
        username: this.predefinedUsername
      });
      this.formService.events$.pipe(takeWhileAlive(this.destroyRef), filter(e => e instanceof FsOnAfterSaveEvent)).subscribe(({
        responseData,
        error
      }) => {
        if (error) {
          this.messages.push(error);
        } else {
          this.completed = true;
        }
      });
      this.formService.initialize();
    }
    validateToken(token) {
      return this.api.sendRequest(ValidateResetTokenRequest, {
        token
      }).pipe(map(response => {
        const valid = response.isValid;
        if (valid) return jwtDecode(token);
        return false;
      }));
    }
    // if a logged-in user visits the password reset page, we can run immediate checks against his/her userRole.
    checkUserAccount(decodedToken) {
      const assignedUserRole = this.store.selectSnapshot(AccessState.role);
      const company = this.store.selectSnapshot(AccessState.accessData('company'));
      const user = this.store.selectSnapshot(AccessState.accessData('user'));
      const accountRoleIsExcludedFromQrCodeReset = roleCheck(UserRole.MANAGER, assignedUserRole);
      if (accountRoleIsExcludedFromQrCodeReset) {
        this.invalidUserRoleError = true;
      }
      //  if user is logged in, make sure the creator of the token is his/her manager actually.
      if (company) {
        const companyId = company?.id;
        if (!companyId || decodedToken.data.companyId !== companyId) {
          this.invalidTeamError = true;
        }
      }
      if (user) {
        this.predefinedUsername = user.username;
      }
    }
    static {
      this.ɵfac = function PasswordResetQrcodeComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || PasswordResetQrcodeComponent)(i0.ɵɵdirectiveInject(i1.LocalMessageHandlerService), i0.ɵɵdirectiveInject(i2.ActivatedRoute), i0.ɵɵdirectiveInject(i2.Router), i0.ɵɵdirectiveInject(i1.AccessService), i0.ɵɵdirectiveInject(i1.AppRequestService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i3.ConfigService), i0.ɵɵdirectiveInject(i4.Store), i0.ɵɵdirectiveInject(i5.ModelFormServiceFactory));
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: PasswordResetQrcodeComponent,
        selectors: [["user-password-reset-qrcode"]],
        features: [i0.ɵɵProvidersFeature([LocalMessageHandlerService])],
        decls: 8,
        vars: 3,
        consts: [["editorForm", "ngForm"], ["size", "medium"], [1, "box"], ["type", "info"], ["type", "warn"], ["id", "editorForm", 3, "formGroup"], ["id", "editorForm", 3, "ngSubmit", "formGroup"], [3, "placeholder"], ["formControlName", "username", 1, "ui-width-stretch", 3, "autocomplete"], ["type", "password", "formControlName", "password", 1, "ui-width-stretch", 3, "autocomplete"], ["type", "password", "formControlName", "password2", 1, "ui-width-stretch", 3, "autocomplete"], [1, "ui-clearfix"], ["uiButton", "", 3, "formSubmitButton"], ["type", "success"], ["uiButton", "", "label", "Jetzt einloggen", 3, "routerLink"]],
        template: function PasswordResetQrcodeComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "ui-content-centered")(1, "ui-card", 1)(2, "div", 2)(3, "h2");
            i0.ɵɵtext(4, "Neues Passwort festlegen");
            i0.ɵɵelementEnd();
            i0.ɵɵconditionalCreate(5, PasswordResetQrcodeComponent_Conditional_5_Template, 7, 5, "p");
            i0.ɵɵconditionalCreate(6, PasswordResetQrcodeComponent_Conditional_6_Template, 4, 4);
            i0.ɵɵconditionalCreate(7, PasswordResetQrcodeComponent_Conditional_7_Template, 4, 4);
            i0.ɵɵelementEnd()()();
          }
          if (rf & 2) {
            i0.ɵɵadvance(5);
            i0.ɵɵconditional(!ctx.loading && !ctx.noTokenError ? 5 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.hasSecurityError ? 6 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(!ctx.hasSecurityError ? 7 : -1);
          }
        },
        dependencies: [CommonModule, FormsModule, i6.ɵNgNoValidate, i6.NgControlStatus, i6.NgControlStatusGroup, ReactiveFormsModule, i6.FormGroupDirective, i6.FormControlName, UiIconsModule, UiContentCenteredComponent, i7.UiCardComponent, UiButtonComponent, UiSpinnerComponent, UiMessageComponent, DynamicFieldsetModule, i8.FormSubmitButtonDirective, UiFieldWrapperComponent, UiInputTextComponent, AppMessagesComponent, RouterLink, i9.AsyncPipe, i9.DatePipe, RouterLinkResolverPipe],
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return PasswordResetQrcodeComponent;
})();